import * as yup from 'yup'
import css from '../../ComplaintForm/ComplaintForm.module.css'
import { InspectMIT } from './pages/inspect.js'
import { commonPageSequence, reviewPage } from '../../../pages'
import { Education } from './education'
import { makeSelectionMessage } from '../../../strings/messages'

export const formSchema = saveComplaint => {
  const initialPages = [
    {
      id: 'education_page',
      validation: yup.object().shape({
        education_ack: yup.string().required(makeSelectionMessage)
      }),
      fields: [
        {
          type: 'content',
          content: Education
        },
        {
          type: 'text',
          name: 'education_ack',
          label: 'Ed Ack',
          value: 'Yes',
          className: css.hidden
        }
      ],
      action: {
        type: 'next',
        buttonText: 'Acknowledge and continue'
      }
    }
  ]

  const finalPages = [reviewPage(InspectMIT)]

  return {
    title: 'Medical Identity Theft Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: initialPages.concat(commonPageSequence(), finalPages)
  }
}
